import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// if (window.matchMedia("(min-width: 1000px)").matches) {
// }

document.addEventListener("DOMContentLoaded", () => {
  // Set initial state (hidden and moved down)
  gsap.set(".skills-card", { opacity: 0, y: 200 });
  gsap.set(".skills-title", { opacity: 0, y: 200 });
  gsap.set(".education-title", { opacity: 0, y: 200 });
  gsap.set(".education-graphic", { opacity: 0, y: 200 });
  gsap.set(".education-text-step", { opacity: 0, y: 200 });
  gsap.set(".projects-title", { opacity: 0, y: 200 });
  gsap.set(".projects-websites", { opacity: 0, y: 50 });
  gsap.set(".design-row .element", { opacity: 0, x: 50 });
  gsap.set(".threed-row .element", { opacity: 0, x: -50 });
  gsap.set(".photo-row .element", { opacity: 0, x: 50 });
  gsap.set(".video-row .element", { opacity: 0, x: -50 });
  gsap.set(".game-row .element", { opacity: 0, x: 50 });

  gsap.to(".skills-card", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    stagger: 0.2, // Each ".skills-card" animates with a 0.1s delay
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".skills", // The element that triggers the animation
      start: "top+=30% 80%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".skills-title", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".skills", // The element that triggers the animation
      start: "top 80%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".education-title", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".education", // The element that triggers the animation
      start: "top 80%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".education-graphic", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".education", // The element that triggers the animation
      start: "top+=30% 80%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".education-text-step", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 0.5,
    ease: "power2.out",
    stagger: -0.5,
    scrollTrigger: {
      trigger: ".education", // The element that triggers the animation
      start: "top+=30% 80%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".projects-title", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".projects", // The element that triggers the animation
      start: "top 80%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".projects-websites", {
    y: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 1,
    ease: "power3.inout",
    scrollTrigger: {
      trigger: ".projects-websites", // The element that triggers the animation
      start: "top-=20% bottom-=20%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".design-row .element", {
    x: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".design-row", // The element that triggers the animation
      start: "top+=10% bottom-=20%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".threed-row .element", {
    x: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".threed-row", // The element that triggers the animation
      start: "top+=10% bottom-=20%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".photo-row .element", {
    x: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".photo-row", // The element that triggers the animation
      start: "top+=10% bottom-=20%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".video-row .element", {
    x: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".video-row", // The element that triggers the animation
      start: "top+=10% bottom-=20%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  gsap.to(".game-row .element", {
    x: 0, // Moves to the original position
    opacity: 1, // Fades in
    duration: 1,
    ease: "power3.inout",
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".game-row", // The element that triggers the animation
      start: "top+=10% bottom-=20%", // Starts animating when the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Plays only once when scrolled into view
      // markers: true,
    },
  });

  function handleTilt() {
    if (window.innerWidth <= 768) {
      // Adjust breakpoint as needed
      document.querySelectorAll(".skills-card").forEach((el) => {
        if (el.vanillaTilt) {
          el.vanillaTilt.destroy(); // Destroy tilt effect
        }
      });
    }
  }

  // Run on page load and when resizing
  handleTilt();
  window.addEventListener("resize", handleTilt);
});
